import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import { safeLocalStorage } from '@/utils/safeStorage';
import VueKonva from 'vue-konva';
import Tres from '@tresjs/core';

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';
import VueApexCharts from 'vue3-apexcharts';
import { configure } from "vue-gtag";

import App from './App.vue';
import router from './router';
import store from './store';
import 'vue-toast-notification/dist/theme-sugar.css';
import '@/assets/css/app-toast.scss';

const clickOutside = {
  beforeMount: (el, binding) => {
    el.clickOutsideEvent = (event) => {
      // here I check that click was outside the el and his children
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        binding.value(event);
      }
    };
    document?.addEventListener("click", el.clickOutsideEvent);
    document.querySelector('.modal')?.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted: (el) => {
    document?.removeEventListener("click", el.clickOutsideEvent);
    document.querySelector('.modal')?.removeEventListener("click", el.clickOutsideEvent);
  },
};

const visibleToggle = (el, binding) => {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
};

const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi',
  },
  components: {
    ...components,
  },
  directives,
  defaults: {
    VTooltip: {
      openDelay: 300,
    },
  },
});

const pinia = createPinia();
pinia.use(createPersistedState({ storage: safeLocalStorage }));

configure({
  tagId: "G-N2QMRM1BZK",
  pageTracker: {
    router,
  },
});

const app = createApp(App)
  .use(store)
  .use(router)
  .use(VueKonva)
  .use(vuetify)
  .use(Tres)
  .use(pinia)
  .use(VueApexCharts)
  .directive('click-outside', clickOutside)
  .directive('visible', visibleToggle);

router.isReady().then(async () => {
  app.mount('#app');
});
